import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { RouteFromObjectType } from "../../common/utilities/RouteFromObjectType";
import restService from "../rest-service/RestService";
import { IDisabledScheduleDTO, ISetPointViewModel } from "./Models";

type UnlinkTagReturnType  = {
    linkedTagCount: number
};

const AlarmSetpointsDataService = {

    getAlarmSetpointData: async function (
        groupID: number,
        eLynxObject: IeLynxObject,
        signal?: AbortSignal
    ): Promise<Array<ISetPointViewModel>> {

        const path = `/groups/${groupID}/${RouteFromObjectType(eLynxObject)}/${eLynxObject.id}/setpoints`;

        const deviceResponse = await restService.get<Array<ISetPointViewModel>>(path, signal);
        return deviceResponse.data;
    },

    acknowledgeAlarm: async function (
        groupID: number,
        tagID: number,
        setpointID: number,
        signal?: AbortSignal): Promise<void> {

        const path: string = `groups/${groupID}/tags/${tagID}/setpoints/${setpointID}/acknowledge`;

        const response = await restService.get<void>(path, signal);
        return response.data;
    },

    // Not sure where to locate these yet

    disableTagSetPoint: async function (
        groupId: number,
        tagId: number,
        setPointId: number,
        disabledSchedule: IDisabledScheduleDTO,
        signal?: AbortSignal
    ): Promise<void> {

        // "~/groups/{groupID:int}/tags/{tagID:int}/setpoints/{setPointID:int}/disable"
        const path = [
            "groups",
            groupId,
            "tags",
            tagId,
            "setpoints",
            setPointId,
            "disable"
        ].join("/");

        /*const response =*/ await restService.put<IDisabledScheduleDTO, void>(path, disabledSchedule, signal);
    },

    enableTagSetPoint: async function (
        groupId: number,
        tagId: number,
        setPointId: number,
        signal?: AbortSignal
    ): Promise<void> {

        // "~/groups/{groupID:int}/tags/{tagID:int}/setpoints/{setPointID:int}/enable"
        const path = [
            "groups",
            groupId,
            "tags",
            tagId,
            "setpoints",
            setPointId,
            "enable"
        ].join("/");

        await restService.put<undefined, void>(path, undefined, signal);
    },


    getDisabledScheduleForTagSetPoint: async function (
        groupId: number,
        tagId: number,
        setPointId: number,
        signal?: AbortSignal
    ): Promise<IDisabledScheduleDTO> {

        // "~/groups/{groupID:int}/tags/{tagID:int}/setpoints/{setPointID:int}/disabledSchedule"
        const path = [
            "groups",
            groupId,
            "tags",
            tagId,
            "setpoints",
            setPointId,
            "disabledSchedule"
        ].join("/");

        const response = await restService.get<IDisabledScheduleDTO>(path, signal);
        return response.data;
    },
    deleteTagSetPoint: async function(groupID: number, tagID: number, setpointID: number): Promise<number> {

        const path = `groups/${groupID}/tags/${tagID}/setpoints/${setpointID}`;
       
        const response = await restService.delete<UnlinkTagReturnType>(path);
        return response.data.linkedTagCount;
    },

    disableObjectSetPoints: async function (
        groupID: number,
        objectType: eLynxObjectTypeEnum,
        objectID: number,
        disabledSchedule: IDisabledScheduleDTO,
        signal?: AbortSignal
    ): Promise<void> {
        // "~/groups/{groupID:int}/objects/{objectType:int}/{objectID:int}/setpoints/disable"
        const path = `groups/${groupID}/objects/${objectType}/${objectID}/setpoints/disable`;

        await restService.put<IDisabledScheduleDTO, void>(path, disabledSchedule, signal);
    },
    enableObjectSetPoints: async function (
        groupID: number,
        objectType: eLynxObjectTypeEnum,
        objectID: number,
        signal?: AbortSignal
    ): Promise<void> {
        // "~/groups/{groupID:int}/objects/{objectType:int}/{objectID:int}/setpoints/enable"
        const path = `groups/${groupID}/objects/${objectType}/${objectID}/setpoints/enable`;

        await restService.put<undefined, void>(path, undefined, signal);
    },
    getDisabledScheduleForObjectSetPoints: async function (
        groupId: number,
        objectType: eLynxObjectTypeEnum,
        objectID: number,
        signal?: AbortSignal
    ): Promise<IDisabledScheduleDTO> {
        // "~/groups/{groupID:int}/objects/{objectType:int}/{objectID:int}/setpoints/disabledSchedule"
        const path = `groups/${groupId}/objects/${objectType}/${objectID}/setpoints/disabledSchedule`;

        const response = await restService.get<IDisabledScheduleDTO>(path, signal);
        return response.data;
    }
};

export default AlarmSetpointsDataService;